// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog-card-preview {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 17.1875rem;
  height: 26.5625rem;
  border-radius: 0.5rem;
  background-color: rgba(var(--white));
  cursor: pointer;
  animation: 0.3s show2 ease;
}
@media (max-width: 768px) {
  .catalog-card-preview {
    width: 9.6875rem;
    height: 19.5625rem;
    border-radius: 0.25rem;
  }
}
.catalog-card-preview__content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.5rem;
  height: 100%;
}
.catalog-card-preview__content-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.catalog-card-preview__img {
  min-height: 17.1875rem;
  height: 17.1875rem;
  border-radius: 0.5rem;
  object-fit: contain;
  display: block;
  position: relative;
}
.catalog-card-preview__img::after {
  content: "";
  position: absolute;
  inset: 0;
  background-color: rgba(var(--blue-grey-300));
}
@media (max-width: 768px) {
  .catalog-card-preview__img {
    min-height: 10.9375rem;
    height: 10.9375rem;
    border-radius: 0.25rem;
  }
}
.catalog-card-preview__plug {
  box-sizing: border-box;
  min-height: 17.1875rem;
  height: 17.1875rem;
  border-radius: 0.5rem;
  background-color: rgba(var(--grey-100));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2.75rem;
}
@media (max-width: 768px) {
  .catalog-card-preview__plug {
    min-height: 10.9375rem;
    height: 10.9375rem;
    border-radius: 0.25rem;
    padding: 1rem;
  }
}
.catalog-card-preview__plug-logo {
  width: 100%;
}
.catalog-card-preview__brand {
  font-size: 0.875rem;
  line-height: 1.57;
  color: rgba(var(--grey-800));
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
@media (max-width: 768px) {
  .catalog-card-preview__brand {
    font-size: 0.75rem;
    line-height: 1.5;
  }
}
.catalog-card-preview__name {
  font-family: var(--merriweather);
  font-size: 1rem;
  line-height: 1.625;
  color: rgba(var(--grey-800));
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.catalog-card-preview__name_vertical {
  -webkit-box-orient: vertical;
}
@media (max-width: 768px) {
  .catalog-card-preview__name {
    font-size: 0.875rem;
    line-height: 1.57;
  }
}
.catalog-card-preview__material {
  font-size: 0.875rem;
  line-height: 1.57;
  color: rgba(var(--grey-600));
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.catalog-card-preview__price {
  font-size: 0.875rem;
  line-height: 1.57;
  color: rgba(var(--orange));
}

.catalog-card-preview-skeleton {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 17.1875rem;
  height: 21.25rem;
  background-color: rgba(var(--white));
}
@media (max-width: 768px) {
  .catalog-card-preview-skeleton {
    width: 9.6875rem;
    height: 19.5625rem;
    border-radius: 0.5rem;
  }
}
.catalog-card-preview-skeleton__img {
  position: relative;
  overflow: hidden;
  height: 17.1875rem;
  width: 100%;
  border-radius: 0.5rem;
  background-color: rgba(var(--blue-grey-300));
}
@media (max-width: 768px) {
  .catalog-card-preview-skeleton__img {
    height: 15.75rem;
    border-radius: 0.5rem;
  }
}
.catalog-card-preview-skeleton__brand {
  position: relative;
  overflow: hidden;
  width: 100%;
  border-radius: 0.25rem;
  height: 1.375rem;
  background-color: rgba(var(--blue-grey-300));
}
@media (max-width: 768px) {
  .catalog-card-preview-skeleton__brand {
    height: 1.5rem;
  }
}
.catalog-card-preview-skeleton__name {
  position: relative;
  overflow: hidden;
  width: 10rem;
  border-radius: 0.25rem;
  height: 1.625rem;
  background-color: rgba(var(--blue-grey-300));
}
@media (max-width: 768px) {
  .catalog-card-preview-skeleton__name {
    width: 6rem;
    height: 1.5rem;
  }
}

.catalog-card-preview-skeleton__img:after,
.catalog-card-preview-skeleton__brand:after,
.catalog-card-preview-skeleton__name:after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  animation: shimmer 1.4s infinite;
  background-image: linear-gradient(90deg, rgba(var(--white), 0) 0%, rgba(var(--white), 0.2) 20%, rgba(var(--white), 0.5) 60%, rgba(var(--white), 0));
}`, "",{"version":3,"sources":["webpack://./src/components/CatalogCardPreview/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oCAAA;EACA,eAAA;EACA,0BAAA;AACF;AACE;EAXF;IAYI,gBAAA;IACA,kBAAA;IACA,sBAAA;EAEF;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;AAEJ;AAAI;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAEN;AAEE;EACE,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAAJ;AAEI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,4CAAA;AAAN;AAGI;EAfF;IAgBI,sBAAA;IACA,kBAAA;IACA,sBAAA;EAAJ;AACF;AAGE;EACE,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AADJ;AAGI;EAXF;IAYI,sBAAA;IACA,kBAAA;IACA,sBAAA;IACA,aAAA;EAAJ;AACF;AAEI;EACE,WAAA;AAAN;AAIE;EACE,mBAAA;EACA,iBAAA;EACA,4BAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAFJ;AAII;EARF;IASI,kBAAA;IACA,gBAAA;EADJ;AACF;AAIE;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;AAFJ;AAII;EACE,4BAAA;AAFN;AAKI;EAbF;IAcI,mBAAA;IACA,iBAAA;EAFJ;AACF;AAKE;EACE,mBAAA;EACA,iBAAA;EACA,4BAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAHJ;AAME;EACE,mBAAA;EACA,iBAAA;EACA,0BAAA;AAJJ;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,oCAAA;AALF;AAOE;EARF;IASI,gBAAA;IACA,kBAAA;IACA,qBAAA;EAJF;AACF;AAME;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,4CAAA;AAJJ;AAMI;EARF;IASI,gBAAA;IACA,qBAAA;EAHJ;AACF;AAME;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,4CAAA;AAJJ;AAMI;EARF;IASI,cAAA;EAHJ;AACF;AAME;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,4CAAA;AAJJ;AAMI;EARF;IASI,WAAA;IACA,cAAA;EAHJ;AACF;;AAMA;;;EAGE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,4BAAA;EACA,gCAAA;EACA,mJAAA;AAHF","sourcesContent":[".catalog-card-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  width: 17.1875rem;\n  height: 26.5625rem;\n  border-radius: 0.5rem;\n  background-color: rgba(var(--white));\n  cursor: pointer;\n  animation: 0.3s show2 ease;\n\n  @media (max-width: 768px) {\n    width: 9.6875rem;\n    height: 19.5625rem;\n    border-radius: 0.25rem;\n  }\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 0.5rem;\n    height: 100%;\n\n    &-info {\n      display: flex;\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n  }\n\n  &__img {\n    min-height: 17.1875rem;\n    height: 17.1875rem;\n    border-radius: 0.5rem;\n    object-fit: contain;\n    display: block;\n    position: relative;\n\n    &::after {\n      content: '';\n      position: absolute;\n      inset: 0;\n      background-color: rgba(var(--blue-grey-300));\n    }\n\n    @media (max-width: 768px) {\n      min-height: 10.9375rem;\n      height: 10.9375rem;\n      border-radius: 0.25rem;\n    }\n  }\n\n  &__plug {\n    box-sizing: border-box;\n    min-height: 17.1875rem;\n    height: 17.1875rem;\n    border-radius: 0.5rem;\n    background-color: rgba(var(--grey-100));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2.75rem;\n\n    @media (max-width: 768px) {\n      min-height: 10.9375rem;\n      height: 10.9375rem;\n      border-radius: 0.25rem;\n      padding: 1rem;\n    }\n\n    &-logo {\n      width: 100%;\n    }\n  }\n\n  &__brand {\n    font-size: 0.875rem;\n    line-height: 1.57;\n    color: rgba(var(--grey-800));\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n\n    @media (max-width: 768px) {\n      font-size: 0.75rem;\n      line-height: 1.5;\n    }\n  }\n\n  &__name {\n    font-family: var(--merriweather);\n    font-size: 1rem;\n    line-height: 1.625;\n    color: rgba(var(--grey-800));\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n\n    &_vertical {\n      -webkit-box-orient: vertical;\n    }\n\n    @media (max-width: 768px) {\n      font-size: 0.875rem;\n      line-height: 1.57;\n    }\n  }\n\n  &__material {\n    font-size: 0.875rem;\n    line-height: 1.57;\n    color: rgba(var(--grey-600));\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n\n  &__price {\n    font-size: 0.875rem;\n    line-height: 1.57;\n    color: rgba(var(--orange));\n  }\n}\n\n.catalog-card-preview-skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  width: 17.1875rem;\n  height: 21.25rem;\n  background-color: rgba(var(--white));\n\n  @media (max-width: 768px) {\n    width: 9.6875rem;\n    height: 19.5625rem;\n    border-radius: 0.5rem;\n  }\n\n  &__img {\n    position: relative;\n    overflow: hidden;\n    height: 17.1875rem;\n    width: 100%;\n    border-radius: 0.5rem;\n    background-color: rgba(var(--blue-grey-300));\n\n    @media (max-width: 768px) {\n      height: 15.75rem;\n      border-radius: 0.5rem;\n    }\n  }\n\n  &__brand {\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    border-radius: 0.25rem;\n    height: 1.375rem;\n    background-color: rgba(var(--blue-grey-300));\n\n    @media (max-width: 768px) {\n      height: 1.5rem;\n    }\n  }\n\n  &__name {\n    position: relative;\n    overflow: hidden;\n    width: 10rem;\n    border-radius: 0.25rem;\n    height: 1.625rem;\n    background-color: rgba(var(--blue-grey-300));\n\n    @media (max-width: 768px) {\n      width: 6rem;\n      height: 1.5rem;\n    }\n  }\n}\n.catalog-card-preview-skeleton__img:after,\n.catalog-card-preview-skeleton__brand:after,\n.catalog-card-preview-skeleton__name:after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  animation: shimmer 1.4s infinite;\n  background-image: linear-gradient(\n    90deg,\n    rgba(var(--white), 0) 0%,\n    rgba(var(--white), 0.2) 20%,\n    rgba(var(--white), 0.5) 60%,\n    rgba(var(--white), 0)\n  );\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
